<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? '发布新任务' : '保存任务信息'" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" :label-width="$i18n.locale === 'en-US' ? '120px' : '140px'">
      <!-- <el-form-item label="任务发布编号" prop="taskCode">
        <el-input v-model="dataForm.taskCode" placeholder="自动生成" :disabled="true" style="border: none"></el-input>
      </el-form-item> -->
      <el-form-item label="任务大类" prop="taskType">
          <ren-select v-model="dataForm.taskType" dict-type="taskType"></ren-select>
      </el-form-item>
          <el-form-item label="任务简述" prop="taskDesc">
          <el-input type="textarea" rows="2" v-model="dataForm.taskDesc" placeholder="任务简述" show-word-limit></el-input>
      </el-form-item>
          <el-form-item label="结算价格及结算方式" label-width="200px" prop="taskRequire">
          <el-input type="textarea" rows="4" v-model="dataForm.taskRequire" placeholder="结算价格及结算方式" show-word-limit></el-input>
      </el-form-item>
	  <el-row>
		  <el-col :md="24" :lg="8">
			  <el-form-item label="需求人数" prop="requirePerson">
				  <el-input v-model="dataForm.requirePerson" placeholder="需求人数" type="number" maxlength="2"></el-input>
			  </el-form-item>
		  </el-col>
		  <el-col :md="24" :lg="8">
			  <el-form-item label="预算金额" prop="budget">
				  <el-input v-model="dataForm.budget" placeholder="预算金额" type="number" maxlength="10"></el-input>
			  </el-form-item>
		  </el-col>
		  <el-col :md="24" :lg="8">
			  <el-form-item label="关联合同编号" prop="contractCode">
				  <el-select v-model="dataForm.contractCode" placeholder="合同编号">
            <el-option v-for="item in options" :key="item" :label="item" :value="item">
					</el-option>
				  </el-select>
			  </el-form-item>
		  </el-col>
	  </el-row>
		 <el-form-item label="任务周期" prop="startDate">
		 					<el-date-picker v-model="dataForm.startDate" start-placeholder="开始日期" align="right" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:SS"></el-date-picker>
		 					  ~
		 					<el-date-picker v-model="dataForm.endDate" end-placeholder="结束日期" align="right"  type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:SS"></el-date-picker>
		 </el-form-item>
		 <el-form-item>
			<el-checkbox v-model="checked">我已阅读并同意<font color="#2C4BD5">财天下共享经济服务平台《信息发布承诺书》</font></el-checkbox>
		 </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button type="primary" @click="dataFormSubmitHandle('1')">任务发布</el-button>
      <el-button v-no-more-click  type="primary" style="background-color: skyblue" @click="dataFormSubmitHandle('0')">保存</el-button>
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        taskDesc: '',
        taskRequire: '',
        requirePerson: '',
        budget: '',
        contractCode: '',
        startDate: '',
        endDate: '',
        status: '',
        creator: '',
        createDate: '',
        updater: '',
        updateDate: '',
        taskCode: '',
        taskType: '',
        taskStatus: ''
      },
      options: []
    }
  },
  computed: {
    dataRule () {
      return {
        taskDesc: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        taskType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        taskRequire: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        requirePerson: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        budget: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        contractCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        startDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        endDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.getContract()
  },
  methods: {
    getContract () {
      this.$http.get(`/sys/plat/contract/getContractCodeList`).then(({ data: res }) => {
        console.log(res)
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.options = res.data
      }).catch(() => {})
    },
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/plat/task/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function (inStatus) {
      this.dataForm.taskStatus = inStatus
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/plat/task/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
